import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import PageNotFound from "../pages/extra-pages/PageNotFound";
import TakeCourse from "../pages/landing-page/TakeCourse";
import TakeScormCourse from "../pages/landing-page/TakeScormCourse";
import ScormCourseList from "../pages/landing-page/ScormCourseList";
import CaughtYou from "../pages/landing-page/CaughtYou";
import TwoStageLandingPage from "../pages/landing-page/TwoStageLandingPage";
import CustomLandingPage from "../pages/landing-page/CustomLandingPage";
import UssLogin from "../pages/landing-page/UssLogin";
import OutlookPluginHandler from "../pages/tenancy/outlookPluginHandler";
import CnLogin from "../pages/authentication/CnLogin";
import AdminConsentCallback from "../pages/authentication/AdminConsentCallback";

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const SsoLogin = Loadable(lazy(() => import('pages/authentication/SsoLogin')));
const GoogleSsoLogin = Loadable(lazy(() => import('pages/authentication/GoogleSsoLogin')));
const ForgotPassword = Loadable(lazy(() => import('pages/authentication/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('pages/authentication/ResetPassword')));
const AliasLogin = Loadable(lazy(() => import('pages/authentication/AliasLogin')));
const OktaOauthAuthorise = Loadable(lazy(() => import('pages/authentication/OktaOauthAuthorise')));
const OktaSsoLogin = Loadable(lazy(() => import('pages/authentication/OktaSsoLogin')));
const MfaSetup = Loadable(lazy(() => import('pages/authentication/MfaSetup')));
const MfaLogin = Loadable(lazy(() => import('pages/authentication/MfaLogin')));


// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: 'login',
            element: <AuthLogin />
        },
        {
            path: 'forgot-password',
            element: <ForgotPassword />
        },
        {
            path: 'login/reset-password',
            element: <ResetPassword />
        },
        {
            path: 'sso/*',
            element: <SsoLogin />
        },
        {
            path: 'oktasso_initiate/*',
            element: <OktaOauthAuthorise />
        },
        {
            path: 'oktasso/*',
            element: <OktaSsoLogin />
        },
        {
            path: 'google-sso/*',
            element: <GoogleSsoLogin />
        },
        {
            path: 'outlookPluginHandler',
            element: <OutlookPluginHandler />
        },
        {
            path: 'dylan',
            element: <ForgotPassword />
        },
        {
            path: "/universitycourse/takecourse/*",
            element: <TakeCourse />
        },
        {
            path: "/scormcourses",
            element: <ScormCourseList />
        },
        {
            path: "/takescormcourse/:courseId",
            element: <TakeScormCourse />
        },
        {
            path: "/campaignclicked/*",
            element: <CaughtYou />
        },
        {
            path: "/landingpage/*",
            element: <TwoStageLandingPage />
        },
        {
            path: "/customlandingpage/*",
            element: <CustomLandingPage />
        },
        {
            path: "/aliaslogin",
            element: <AliasLogin />
        },
        {
            path:"uss-login",
            element: <UssLogin />
        },
        {
            path:"cn-sso",
            element: <CnLogin />
        },
        {
            path: 'mfa-setup',
            element: <MfaSetup />
        },
        {
            path: 'login-mfa',
            element: <MfaLogin />
        },
        {
            path: 'admin-consent.html',
            element: <AdminConsentCallback />
        },
        {
            path: '*',
            element: <PageNotFound />
        },
    ]
};

export default LoginRoutes;
